
export default function themeLoader(){


    const municipality = findMunicipality();
    if (municipality === '')
        return;

    loadStyleSheet(`/${municipality}.css`);
    setIcons(municipality)
    
    function loadStyleSheet(url: string){
        var sheet = document.createElement('link');
        sheet.rel = 'stylesheet';
        sheet.href = url;
        sheet.type = 'text/css';
        document.head.appendChild(sheet);
    }

    function findMunicipality(): string {
        let municipalities = ["amli", "arendal", "froland", "gjerstad", "grimstad", "iveland", "risor", "tvedestrand", "vegarshei", "vennesla"];
        let hostName = window.location.hostname;
        var municipality = '';
        municipalities.forEach((c) => {
            if (hostName.includes(c))
                municipality = c;
        });

        if (municipality === ''){
            // find city from querystring
            const queryParams = new URLSearchParams(window.location.search);
            municipality = queryParams.get('kommune') ?? '';
        }

        if(municipality === ''){
            // try to get from localstorage
            const storedMunicipality = localStorage.getItem('municipality');
            const foundMunic = municipalities.filter(m => m === storedMunicipality);
            if (foundMunic && foundMunic.length > 0) {
                municipality = foundMunic[0] ?? '';
            }
        }

        if (municipality === '')
        {
            console.log('Defaulting to arendal stylesheet');
            municipality = 'arendal';
        }

        return municipality;
    }

    function setIcons(municipality: string) {
        const headerLinks = document.head.getElementsByTagName('link')

        var favIcon = headerLinks.namedItem('favicon');
        if(favIcon){
            favIcon.href = `/${municipality}/favicon.ico`
        }

        var touchIcon = headerLinks.namedItem('touchicon');
        if(touchIcon){
            touchIcon.href = `/${municipality}/apple-touch-icon.png`
        }
    }
}